import { Box, Stack, styled } from "@mui/material";
import type { Theme } from "@mui/material/styles";

// QA fix (A2): the row used flex-start + a hard-coded 32px top padding on the
// number label to fake-align the "1." marker with the field. That drifted out
// of alignment whenever field height changed. Centering the row and dropping
// the padding keeps the number vertically centered against its fields.
export const StatementRow = styled(Stack)({
	flexDirection: "row",
	alignItems: "center",
	marginBottom: 8,
	width: "100%",
	minWidth: 0,
});

export const StatementNumberLabel = styled(Box)(({ theme }: { theme: Theme }) => ({
	minWidth: 24,
	textAlign: "center",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	color: theme.palette.text.secondary,
	fontWeight: 500,
}));

export const StatementContentBox = styled(Box)(({ theme }: { theme: Theme }) => ({
	alignItems: "center",
	display: "flex",
	borderRadius: theme.spacing(2),
	border: "1px solid",
	borderColor: theme.palette.divider,
	backgroundColor: theme.palette.background.paper,
	padding: theme.spacing(2),
	flex: 1,
	minWidth: 0,
}));

export const StatementFieldsRow = styled(Stack)(({ theme }: { theme: Theme }) => ({
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "flex-start",
	gap: theme.spacing(2),
	width: "100%",
	minWidth: 0,
	"& > .MuiAutocomplete-root": {
		flex: "1 1 0",
		minWidth: 0,
		width: "auto",
	},
	"& > .MuiFormControl-root": {
		minWidth: 0,
	},
	"& > *:last-child": {
		flexShrink: 0,
	},
}));
